import { Capacitor } from '@capacitor/core'

export const isCapacitor = Capacitor.isNativePlatform()
